import { render } from "./boardOverview.vue?vue&type=template&id=dc9992e8"
import script from "./boardOverview.vue?vue&type=script&lang=ts"
export * from "./boardOverview.vue?vue&type=script&lang=ts"
script.render = render

export default script